import { SVGAttributes } from "react"

export function EditIcon(props: SVGAttributes<SVGSVGElement>) {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_116_1205)">
                <path
                    d="M27.3137 4.68629C28.8758 6.24839 28.8758 8.78105 27.3137 10.3431L12.5408 25.1161C11.9 25.7569 11.0971 26.2115 10.2179 26.4312L5.63593 27.5767C4.90355 27.7598 4.24016 27.0964 4.42325 26.3641L5.56875 21.7821C5.78854 20.9029 6.24314 20.1 6.88393 19.4592L21.6569 4.68629C23.219 3.12419 25.7516 3.12419 27.3137 4.68629ZM20.2425 8.92872L8.29815 20.8734C7.91367 21.2579 7.64091 21.7396 7.50904 22.2671L6.76777 25.2322L9.73286 24.491C10.2604 24.3591 10.7421 24.0863 11.1266 23.7019L23.0705 11.7567L20.2425 8.92872ZM23.0711 6.1005L21.6565 7.51472L24.4845 10.3427L25.8995 8.92893C26.6805 8.14788 26.6805 6.88155 25.8995 6.1005C25.1184 5.31945 23.8521 5.31945 23.0711 6.1005Z"
                    fill="#C3C7D3"
                />
            </g>
            <defs>
                <clipPath id="clip0_116_1205">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
